import React, { useState } from 'react';
import Logo from './logowhite.png';
import styles from './style.module.css';
import { Loading } from '../../../Components';
import { AiFillEyeInvisible, AiFillEye } from 'react-icons/ai';
import ReactGA from 'react-ga';
import { Link } from 'react-router-dom';

const Login = ({
  form,
  handleSubmit,
  handleChange,
  error,
  loading,
}) => {
  const [passwordType, setPasswordType] = useState("password");

  const togglePassword = () => {
    ReactGA.event({
      category: 'Botão',
      action: 'Clique',
      label: 'Visualizar senha'
    });

    setPasswordType((prev) => (prev === "password" ? "text" : "password"));
  };

  return (
    <Loading show={loading}>
      <div className={styles.loginContainer}>
        <div className={styles.left}>
          <img src={Logo} alt="Logo" />
        </div>
        <div className={styles.right}>
          <div className={styles.cardForm}>
            <div className={styles.cardFormHeader}>
              <h4 className={styles.textInfo}>Entrar</h4>
              <p>Insira seu usuário e senha para acessar.</p>
            </div>

            <div className={styles.inputsContainer}>
              <div className={styles.formGroup}>
                <label className={styles.formItem}>
                  E-mail *
                  <input
                    type="email"
                    name="email"
                    placeholder="Digite o e-mail"
                    value={form.email}
                    onChange={handleChange}
                  />
                </label>
              </div>

              <div className={styles.formGroup}>
                <label className={styles.formItem}>
                  Senha *
                  <div className={styles.passContainer}>
                    <input
                      type={passwordType}
                      name="password"
                      placeholder="Digite a senha"
                      value={form.password}
                      onChange={handleChange}
                    />
                    <button
                      type="button"
                      className={styles.passType}
                      onClick={togglePassword}
                    >
                      {passwordType === "password" ? <AiFillEyeInvisible /> : <AiFillEye />}
                    </button>
                  </div>
                </label>
              </div>
            </div>

            <button onClick={handleSubmit} className={styles.btnSubmit}>
              Entrar
            </button>

            <p className={styles.forgotPasswordLink}>
              <Link to="/forgot-password">Esqueceu sua senha?</Link>
            </p>

            <div className={styles.errorMessage}>
              <small>{error}</small>
            </div>
          </div>
        </div>
      </div>
    </Loading>
  );
};

export default Login;
